/* ••[1]••••••••••••••••••••••••• testimonialQuote.ts •••••••••••••••••••••••••••••• */
import { Component, CustomElement } from "../../core/CustomElement";
import {
  TestimonialQuote,
  validatedTestimonialQuote,
} from "../../core/types/TestimonialQuote";
import { validateJsonStringified } from "../../core/utilities";

@Component("ccc-testimonial-quote", {
  template: require("./testimonialQuote.html").default,
  style: require("./testimonialQuote.scss").default,
  viewModel: require("./testimonialQuoteVm"),
  observedAttributes: ["testimonial-quote"],
})
export default class CCCTestimonialQuote extends CustomElement {
  constructor() {
    super();
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: unknown,
    newValue: unknown
  ): void {
    switch (attr) {
      case "testimonial-quote": {
        const newValueObj: TestimonialQuote = validateJsonStringified(
          newValue as string
        );

        this.viewModel.testimonialQuote(validatedTestimonialQuote(newValueObj));
        break;
      }
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public set testimonialQuote(value: TestimonialQuote) {
    if (typeof value === "object") {
      this.viewModel.testimonialQuote(validatedTestimonialQuote(value));
    }
  }
}

// https://www.figma.com/file/8dAQp4d1MS6YQt44jWZSYu/Vanilla?node-id=1380%3A18972
